import { useLanguage } from "../lang/LanguageContext";
import { Link } from "react-router-dom";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaChalkboardTeacher, FaTerminal } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { LuPresentation } from "react-icons/lu";



export default function Header() {
  const { lang, setLang , strings} = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="border-b w-full">
      <div className="max-w-7xl mx-auto flex items-center justify-between py-4 px-6">
      <Link
        to="/"
        className="text-xl font-semibold hover:text-blue-700"
      >
        {strings.name}
        </Link>
      {/* Hamburger button for mobile */}
      <button
        className="md:hidden text-blue-700 focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <RxHamburgerMenu className="w-6 h-6" />
      </button>
      <nav
        className={`
          fixed md:static top-16 md:top-auto
            left-0 right-0 md:left-auto md:right-auto
            bg-white md:bg-transparent
            md:flex md:justify-between
            md:w-[80%]
            ${menuOpen ? "flex flex-col" : "hidden"}
            md:flex
            z-20
            border-b md:border-none
            md:py-0 py-4
            px-6 md:px-0
            md:justify-center
            md:space-x-6
        `}
      >
        <Link
  to="/experience"
  className="block py-2 md:py-0 text-black font-semibold hover:text-blue-700 transition flex items-center gap-2"
  onClick={() => setMenuOpen(false)}
>
  <FiFileText size={20} />
  {strings.experiencePage.title}
</Link>


<Link
  to="/talks"
  className="block py-2 md:py-0 text-black font-semibold hover:text-blue-700 transition flex items-center gap-2"
  onClick={() => setMenuOpen(false)}
>
  <LuPresentation size={20} />
  {strings.expose.title}
</Link>

<Link
  to="/softwares"
  className="block py-2 md:py-0 text-black font-semibold hover:text-blue-700 transition flex items-center gap-2"
  onClick={() => setMenuOpen(false)}
>
  <FaTerminal size={20} />
  {strings.software.title}
</Link>
      

<Link
  to="/teaching"
  className="block py-2 md:py-0 text-black font-semibold hover:text-blue-700 transition flex items-center gap-2"
  onClick={() => setMenuOpen(false)}
>
  <FaChalkboardTeacher size={20} />
  {strings.teaching.title}
</Link>

      
      <div className="flex space-x-4 py-2 md:py-0 md:ml-4">
        <button
          onClick={() => {
              setLang("fr");
              setMenuOpen(false);
            }}
          className={lang === "fr" ? "font-bold underline" : ""}
        >
          🇫🇷 FR
        </button>
        <button
          onClick={() => {
              setLang("en");
              setMenuOpen(false);
            }}
          className={lang === "en" ? "font-bold underline" : ""}
        >
          🇬🇧 EN
        </button>
      </div>
      </nav>
      </div>
    </header>
  );
}
